// extracted by mini-css-extract-plugin
export default {"GiftWrapWhyContent":"GiftWrapWhy_GiftWrapWhyContent__SiEtP","GiftWrapWhy":"GiftWrapWhy_GiftWrapWhy__m2peK","GiftWrapWhyImg":"GiftWrapWhy_GiftWrapWhyImg__A6WI2"};